import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {CassaPrevidenzialeModalComponent} from './cassa-previdenziale-modal-component';

export const CassaPrevidenzialeModalModule: string = ng
  .module('cassa-previdenziale-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('cassaPrevidenzialeModalComponent', CassaPrevidenzialeModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/component/cassa-previdenziale-modal-component/cassa-previdenziale-modal-component.module.ts